//
// Zone.
function ANZoneDictionaryItem(zoneInfo, intersectionObserver){

    // Constants.
    this.ID_POSITION_TYPE_AT    = 1;
    this.ID_POSITION_TYPE_EVERY = 2;

    this.zoneInfo                          = zoneInfo; // TODO: Obfiscate this.
    this.units                             = {};
    this.__key                             = null;
    this.__currentUnitElementId            = null;
    this.__nextUnitElementId               = null;
    this.__previousUnitElementId           = null;
    this.__hasBeenAddedToPage              = false;
    this.__element                         = null;
    this.__chiildren                       = [];
    this.__estimatedAdSpace                = null;
    this.__estimatedAdSpaceWithoutFloating = null;
    this.__currentAdSpace                  = null;
    this.__currentAdSpaceWithoutFloating   = null;
    this.__isInstreamVideo                 = null;
    this.__isNotUsingSpace                 = null;
    this.__canFloat                        = null;
    this.__isAlwaysFloating                = null;
    this.__elementId                       = null;
    this.__isCopy                          = null;
    this.__isRepeatable                    = null;
    this.__repeatableSettings              = null;
    this.__intersectionObserver            = intersectionObserver;
    this.__isInView                        = false;
    this.__isVideo                         = null;
    this.__hasBeenInView                   = false;
}

//
// Returns ID.
ANZoneDictionaryItem.prototype.getKey = function(){

    if(this.__key){
        
        return this.__key;
    }

    this.__key = this.zoneInfo.getKey();

    return this.__key;
};    

//
// Returns the name of the zone.
ANZoneDictionaryItem.prototype.getName = function(){

    return this.zoneInfo.getName();
};

//
// Returns the group name of the zone.
ANZoneDictionaryItem.prototype.getGroupName = function(){

    return this.zoneInfo.getGroupName();    
};

//
// Returns true if zone is a copy.
ANZoneDictionaryItem.prototype.isCopy = function(){

    if(null !== this.__isCopy){
        
        return this.__isCopy;
    }

    this.__isCopy = (!!this.zoneInfo.getBaseKey());

    return this.__isCopy;
};

//
// Returns true if zone has repeatable settings.
ANZoneDictionaryItem.prototype.isRepeatable = function(){

    if(null !== this.__isRepeatable){
        
        return this.__isRepeatable;
    }

    this.__isRepeatable = (!this.isCopy() && !!this.getRepeatableSettings());

    return this.__isRepeatable;
};

//
// originalItemElementId
ANZoneDictionaryItem.prototype.getOriginalUnitElementId = function(){

    return this.zoneInfo.originalItemElementId;
};

//
// originalItem
ANZoneDictionaryItem.prototype.getOriginalUnit = function(){

    if(!this.zoneInfo.originalItemElementId || 0 === this.units.length){
        
        return null;
    }

    return this.units[this.zoneInfo.originalItemElementId] || null;
};

//
// currentItemElementId
ANZoneDictionaryItem.prototype.getCurrentUnitElementId = function(){

    return this.__currentUnitElementId;
};
ANZoneDictionaryItem.prototype.setCurrentUnitElementId = function(id){

    this.__currentUnitElementId = id;
};

//
// Returns the current unit.
ANZoneDictionaryItem.prototype.getCurrentUnit = function(){

    return this.units[this.__currentUnitElementId] || null;
};

// 
// nextItemElementId
ANZoneDictionaryItem.prototype.getNextUnitElementId = function(){

    return this.__nextUnitElementId;
};
ANZoneDictionaryItem.prototype.setNextUnitElementId = function(id){

    this.__nextUnitElementId = id;
};

//
// nextItem
ANZoneDictionaryItem.prototype.getNextUnit = function(){
    
    return this.units[this.__nextUnitElementId] || null;
};

//
// previousItemElementId
ANZoneDictionaryItem.prototype.getPreviousUnitElementId = function(){

    return this.__previousUnitElementId;
};
ANZoneDictionaryItem.prototype.setPreviousUnitElementId = function(id){

    this.__previousUnitElementId = id;
};

//
// previousItem
ANZoneDictionaryItem.prototype.getPreviousUnit = function(){

    return this.units[this.__previousUnitElementId] || null;
};

//
// Add an item.
ANZoneDictionaryItem.prototype.addUnit = function(item){

    if(!item.hasOwnProperty('adElementId')){

        return false;
    }

    var elementId = item.adElementId;

    if(this.units.hasOwnProperty(elementId)){
        
        return false;
    }

    if(this.units && Object.keys(this.units).length === 0){
        
        this.setCurrentUnitElementId(elementId);
    }

    if(this.units && Object.keys(this.units).length > 0){

        this.setNextUnitElementId(elementId);
    }

    this.units[elementId] = item;

    return true;
};

/**
 * Return an ad unit if it exists.
 * 
 * @param {string} elementId
 * @returns {AdsNinjaAdUnit|null}
 */
ANZoneDictionaryItem.prototype.getUnit = function(elementId){
    
    if(!elementId || typeof elementId !== 'string'){
        
        return null;
    }

    return this.units[elementId] || null;
};

//
// TODO: This data should be stored in this class/object.
// Returns repeatable settings.
ANZoneDictionaryItem.prototype.getRepeatableSettings = function(){
    
    if(null !== this.__repeatableSettings){
        
        return this.__repeatableSettings;
    }

    var originalUnit          = this.getOriginalUnit();
    this.__repeatableSettings = (originalUnit) ? originalUnit.getRepeatableSettings() : null;

    return this.__repeatableSettings;
};

//
// Returns true if added to page.
ANZoneDictionaryItem.prototype.hasBeenAddedToPage = function(){
    
    return this.__hasBeenAddedToPage;
};

//
// Set added to page.
ANZoneDictionaryItem.prototype.setHasBeenAddedToPage = function(){
    
    if(this.__hasBeenAddedToPage){
        
        return;
    }

    this.__hasBeenAddedToPage = true;

    // TODO: Not using space.
    // TODO: Dependning on floating do something here.
    // TODO: Observe like each zone and the floating container and if either is in-view than the whole zone is in-view.
    // TODO: Maybe don't do this in domain model and instead do this in the service.
    this.__intersectionObserver.observe(this.getElement());
};

/**
 * Returns true if zone is in-view.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.isInView = function(){
    
    var currentUnitElementId = this.getCurrentUnitElementId();

    // TODO: Floating and do not use space.
    if(!this.__isInView && currentUnitElementId && window.adsNinjaHeaderBiddingManager.isAdFloating(this.getCurrentUnitElementId())){
        
        return true;
    }

    return this.__isInView;
};

/**
 * Sets in-view state.
 */
ANZoneDictionaryItem.prototype.setIsInView = function(value){
    
    this.__isInView = value;

    if(value){
        
        this.__hasBeenInView = true;
    }
};

/**
 * Retruns true if the zone has been in-view.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.hasBeenInView = function(){
    
    return this.__hasBeenInView;
};

//
// Returns the element ID.
ANZoneDictionaryItem.prototype.getElementId = function(){

    if(this.__elementId){
        
        return this.__elementId;
    }

    // TODO: Should not need to construct this here.
    this.__elementId = 'adsninja-ad-zone-' + this.zoneInfo.getOriginalItemElementId();

    return this.__elementId;
};

//
// Retruns the element.
ANZoneDictionaryItem.prototype.getElement = function(bustCache = false){

    // HACK: While we wait for full zone manager support we can't do this.
    // if(!this.hasBeenAddedToPage()){

    //     return null;
    // }

    if(!bustCache && this.__element){

        return this.__element;
    }
    
    this.__element = document.getElementById(this.getElementId());

    // HACK: While we wait for full zone manager support we have to do this.
    if(!this.hasBeenAddedToPage() && this.__element){
        
        this.setHasBeenAddedToPage();
    }

    return this.__element;
};

/**
 * Returns true if the zone's unit can float.
 * 
 * @return Boolean
 */
ANZoneDictionaryItem.prototype.canFloat = function(){
    
    if(null !== this.__canFloat){
        
        return this.__canFloat;
    }

    var originalUnit = this.getOriginalUnit();
    this.__canFloat  = (originalUnit) ? originalUnit.canFloat() : false;

    return this.__canFloat;
};

/**
 * Returns true if the zone's unit will always float.
 * 
 * @return Boolean
 */
ANZoneDictionaryItem.prototype.isAlwaysFloating = function(){
    
    if(null !== this.__isAlwaysFloating){
        
        return this.__isAlwaysFloating;
    }

    var originalUnit        = this.getOriginalUnit();
    this.__isAlwaysFloating = (originalUnit) ? originalUnit.isAlwaysFloating() : false;

    return this.__isAlwaysFloating;
};

/**
 * Returns true if zone is not using space.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.isNotUsingSpace = function(){
    
    if(null !== this.__isNotUsingSpace){
        
        return this.__isNotUsingSpace;
    }

    var originalUnit       = this.getOriginalUnit();
    this.__isNotUsingSpace = (originalUnit) ? originalUnit.isNotUsingSpace() : false;

    return this.__isNotUsingSpace;
};

/**
 * Returns true if zone is used for an instream video player.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.isInstreamVideo = function(){
    
    if(null !== this.__isInstreamVideo){
        
        return this.__isInstreamVideo;
    }

    var originalUnit       = this.getOriginalUnit();
    this.__isInstreamVideo = (originalUnit) ? originalUnit.isInstreamVideo() : false;

    return this.__isInstreamVideo;
};

/**
 * Returns true if zone is used for a video player.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.isVideo = function(){
    
    if(null !== this.__isVideo){
        
        return this.__isVideo;
    }

    var originalUnit = this.getOriginalUnit();
    this.__isVideo   = (originalUnit) ? originalUnit.isVideo() : false;

    return this.__isVideo;
};

/**
 * Returns the estimated ad space.
 * 
 * @param {boolean} includeFloating
 * @returns {number}
 */
ANZoneDictionaryItem.prototype.calculateEstimatedAdSpace = function(includeFloating = true){
    
    if(includeFloating && null !== this.__estimatedAdSpace){
        
        return this.__estimatedAdSpace;
    }
    else if(!includeFloating && null !== this.__estimatedAdSpaceWithoutFloating){
        
        return this.__estimatedAdSpaceWithoutFloating;
    }

    var originalUnit = this.getOriginalUnit();

    if(!originalUnit){
        
        return 0;
    }

    var estimatedAdSpace = (this.__estimatedAdSpace) ? this.__estimatedAdSpace : originalUnit.getEstimatedAdSpace(includeFloating);

    if(includeFloating){
        
        this.__estimatedAdSpace = estimatedAdSpace;
    }
    else{
        
        this.__estimatedAdSpaceWithoutFloating = estimatedAdSpace;
    }

    return estimatedAdSpace;
};

/**
 * Returns the ad space.
 * 
 * @param {boolean} includeFloating
 * @returns {number}
 */
ANZoneDictionaryItem.prototype.calculateCurrentAdSpace = function(includeFloating = true, bustCache = true){
    
    if(includeFloating && null !== this.__currentAdSpace && !bustCache){
        
        return this.__currentAdSpace;
    }
    else if(!includeFloating && null !== this.__currentAdSpaceWithoutFloating && !bustCache){
        
        return this.__currentAdSpaceWithoutFloating;
    }

    var originalUnit = this.getOriginalUnit();

    if(!originalUnit){
        
        return 0;
    }

    var currentAdSpace = (this.__currentAdSpace && !bustCache) ? this.__currentAdSpace : originalUnit.getCurrentAdSpace(includeFloating);

    if(includeFloating){
        
        this.__currentAdSpace = currentAdSpace;
    }
    else{
        
        this.__currentAdSpaceWithoutFloating = currentAdSpace;
    }

    return currentAdSpace;
};

/**
 * Returns the zoneInfo object.
 * 
 * @returns {object}
 */
ANZoneDictionaryItem.prototype.getZoneInfo = function(){
    
    return this.zoneInfo;
};

/**
 * Returns true if the current creative has been loaded.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.hasCurrentCreativeBeenLoaded = function(){
    
    var currentUnit = this.getCurrentUnit();

    return (currentUnit) ? currentUnit.hasCreativeBeenLoaded() : false;
};

/**
 * Returns true if current unit's creative has been viewed.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.hasCurrentCreativeBeenViewed = function(){
    
    var currentUnit = this.getCurrentUnit();

    return (currentUnit) ? currentUnit.hasCreativeBeenViewed() : false;
};

/**
 * Returns true if the current creative's minimum timer has completed.
 * 
 * @returns {boolean}
 */
ANZoneDictionaryItem.prototype.hasCreativeMinimumTimerCompleted = function(){
    
    var currentUnit = this.getCurrentUnit();

    return (currentUnit) ? currentUnit.hasCreativeMinimumTimerCompleted() : false;
};

window.ANZoneDictionaryItem = ANZoneDictionaryItem;